import Vue from "vue";
import Vuex from "vuex";

import * as modules from "./modules";
import vuexPersist from "@/plugins/vuex-persist";
import { NODE_ENVS } from "@/constants";

Vue.use(Vuex);

/** Determines if the env is development */
const isDevEnv = process.env.NODE_ENV === NODE_ENVS.dev;

/**
 * Vuex store
 */
const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules,
  devtools: isDevEnv,
  plugins: [vuexPersist.plugin],
});

export default store;
